import { Col } from 'antd';
import styled from 'styled-components';
import Icon from '@ant-design/icons/lib/components/Icon';
import { SVGComponent } from '@tools/ui/types';
import { ExpandIconWrap } from '../../../../../../components/common/icons/expandIconWrap';

const ExpandIcon = styled(Col)({
  marginTop: 0
});

export type TIcon = typeof Icon | SVGComponent;

type TProps = {
  expanded: boolean;
  record: unknown;
  onExpand: (record: unknown, event: React.MouseEvent<HTMLElement>) => void;
  openIcon: TIcon;
  closeIcon: TIcon;
  iconSize?: number;
};

export const TableExpandIcon: React.FC<React.PropsWithChildren<TProps>> = (
  props
) => {
  const {
    expanded,
    onExpand,
    record,
    openIcon,
    closeIcon,
    iconSize = 20
  } = props;

  const onClick = (e) => {
    e.stopPropagation();
    onExpand(record, e);
  };

  return (
    <ExpandIcon>
      <ExpandIconWrap
        onClick={onClick}
        style={{
          marginLeft: 5,
          fontSize: iconSize
        }}
        component={expanded ? openIcon : closeIcon}
      />
    </ExpandIcon>
  );
};
